export default __webpack_public_path__ + "static/media/delete.5fb25a74.svg";